import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaLock, FaSignInAlt } from "react-icons/fa";
import "./ProfileCard.css";

function LockedCard({ user = {}, baseurl = "" }) {
  const navigate = useNavigate();
  const [imgError, setImgError] = useState(false);

  const lockMessages = [
    "🔒 Login to view this profile",
    "💝 Sign in to connect",
    "❤️ Create an account to see details",
    "🔐 Unlock this profile by logging in"
  ];

  const getRandomLockMessage = () => {
    return lockMessages[Math.floor(Math.random() * lockMessages.length)];
  };

  const getDisplayName = () => {
    return user.firstname || user.first_name || user.username || "User";
  };

  // ✅ Real image extract karega, agar nahi hai ya error hai to pehle jaisa UI-Avatar aayega
  const getProfileImage = () => {
    const rawPic =
      user.pic ||
      user.photo ||
      user.photo1 ||
      user.image ||
      user.profile_image ||
      user.avatar;

    // Agar real image hai aur load hone me error nahi aaya
    if (rawPic && !imgError) {
      if (rawPic.startsWith("http://") || rawPic.startsWith("https://")) {
        return rawPic;
      }
      const cleanBase = (baseurl || "").endsWith("/") ? baseurl.slice(0, -1) : (baseurl || "");
      const cleanPath = rawPic.startsWith("/") ? rawPic : `/${rawPic}`;
      return `${cleanBase}${cleanPath}`;
    }

    // Agar photo nahi dali hai to pehle jaisa Avatar
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(getDisplayName())}&background=ff0055&color=fff&size=200`;
  };

  return (
    <div className="res-card res-card-locked">
      <div className="res-card-img-box">
        {/* Real photo blur hokar yahan dikhegi */}
        <img
          src={getProfileImage()}
          alt="Locked Profile"
          className="res-card-img res-blurred"
          onError={() => setImgError(true)}
        />
        
        {/* Lock Overlay */}
        <div className="res-lock-overlay">
          <div className="res-lock-circle">
            <FaLock className="lock-icon" />
          </div>
          <p className="res-lock-text">{getRandomLockMessage()}</p>
          <div className="res-lock-actions">
            <button
              className="res-lock-login-btn"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/User_Login");
              }}
            >
              <FaSignInAlt /> Login
            </button>
            <Link 
              to="/User_Reg" 
              className="res-lock-signup-btn"
              onClick={(e) => e.stopPropagation()}
            >
              Sign Up
            </Link>
          </div>
        </div>
      </div>

      <div className="res-card-body">
        <div className="res-locked-info">
          <div className="res-hidden-name">●●●●●●●●</div>
          <div className="res-hidden-chips">
            <span className="res-chip">🎂 {user.age ? `${user.age} yrs` : "●● yrs"}</span>
            <span className="res-chip">📍 {user.district || user.city || "●●●●●●"}</span>
            <span className="res-chip">🙏 {user.caste || "●●●●●"}</span>
          </div>
          <p className="res-locked-desc">
            Create a free account to view this profile and connect
          </p>
        </div>
        <button
          className="res-login-btn"
          onClick={(e) => {
            e.stopPropagation();
            navigate("/User_Login");
          }}
        >
          <FaSignInAlt /> Login to View Profile
        </button>
        <Link 
          to="/User_Reg" 
          className="res-signup-link"
          onClick={(e) => e.stopPropagation()}
        >
          New here? Sign Up Free →
        </Link>
      </div>
    </div>
  );
}

export default LockedCard;